import React from 'react';
import { VideoThumbnail } from 'containers/jobsite/tabs/jobsitePulse/components/cameras/video/VideoThumbnail';
import { TimelineTrackPoint } from './TimelineTrack';
import { useTimeline } from './TimelineProvider';

/**
 * Timeline slot content.
 *
 * This renders a set of video thumbnails in the track based on either specific timestamps (priority)
 * or this item's unit increment out of the overall unit count for the timeline.
 */
export function TimelineVideoThumbnails(props: {
  items: {
    id: string;
    size?: number;
    time?: number;
    title?: string;
    url: string;
  }[];
}): React.ReactElement {
  const { items } = props;
  const { timelineUnitCount } = useTimeline();
  return (
    <div className="odin-relative odin-overflow-hidden odin-w-full odin-h-[64px]">
      {items?.map(({ id, time, title, url }, i) => (
        <TimelineTrackPoint
          key={`timeline-graphic-${id}`}
          time={time}
          unitIncrement={i}
          size={1 / timelineUnitCount}
        >
          <VideoThumbnail label={title} url={url} />
        </TimelineTrackPoint>
      ))}
    </div>
  );
}
